module.exports = __webpack_public_path__ + "img/website-preview.5fbb08f1.png";